import { render, staticRenderFns } from "./technical.vue?vue&type=template&id=1036ab8d&scoped=true&"
import script from "./technical.vue?vue&type=script&lang=js&"
export * from "./technical.vue?vue&type=script&lang=js&"
import style0 from "./technical.vue?vue&type=style&index=0&id=1036ab8d&scoped=true&lang=css&"
import style1 from "./technical.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036ab8d",
  null
  
)

export default component.exports